import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { AgreementViewAcceptedViewComponent } from './agreement-view-accepted-view/agreement-view-accepted-view.component';
import { AgreementService } from './agreement.service';
import { FiAgreementsListComponent } from './agreements-list/agreements-list.component';
import { ItemsListModule } from '../components/items-list/items-list.module';
import { FiAgreementEditComponent } from './agreement-edit/agreement-edit.component';
import { FiContenteditableSimpleTextPanelHandlerModule } from '../components/fi-contenteditable-simple-text-panel-handler/fi-contenteditable-simple-text-panel-handler.module';
import { FormsModule } from '@angular/forms';
import { FiEditorPageModule } from '../components/fi-editor-page/fi-editor-page.module';
import { FiAgreementViewAgreementComponent } from './agreement-view-agreement/agreement-view-agreement.component';
import { FiAgreementVersionsListComponent } from './agreement-versions-list/agreement-versions-list.component';
import { FiAgreementViewAcceptedComponent } from './agreement-view-accepted/agreement-view-accepted.component';
import { FiAgreementVersionViewComponent } from './agreement-version-view/agreement-version-view.component';
import { MatRadioModule } from '@angular/material/radio';
import { CompareHtmlModule } from '@fi-app/utilities/compare-html/compare-html.module';
import { FiAgreementViewVersionComponent } from './agreement-view-version/agreement-view-version.component';
import { FiAgreementViewComponent } from './agreement-view/agreement-view.component';
import { UIRouterModule } from '@uirouter/angular';
import { AgreementStates } from '@fi-app/agreement/agreement-states';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatButtonModule } from '@angular/material/button';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        CompareHtmlModule,
        UtilitiesModule,
        ItemsListModule,
        FiContenteditableSimpleTextPanelHandlerModule,
        FiEditorPageModule,
        FiValidatingFormModule,
        FiPrintDownloadModule,
        UIRouterModule.forChild(AgreementStates),
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatButtonModule,
        SelectSearchModule,
        FiErrorMessageModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiSimpleContenteditableModule,
    ],
    declarations: [
        AgreementViewAcceptedViewComponent,
        FiAgreementsListComponent,
        FiAgreementEditComponent,
        FiAgreementViewComponent,
        FiAgreementViewAgreementComponent,
        FiAgreementVersionsListComponent,
        FiAgreementViewAcceptedComponent,
        FiAgreementViewVersionComponent,
        FiAgreementVersionViewComponent,
    ],
    providers: [AgreementService],
})
export class AgreementModule {}
